import { defineComponent, h } from 'vue';
import { Line } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale } from 'chart.js';

// Register necessary components from Chart.js
ChartJS.register(CategoryScale, LinearScale, LineElement, Title, Tooltip, Legend);

export default defineComponent({
  name: 'LineChartComponent',
  components: {
    Line
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,  // Changed to true to match the original functionality
            position: 'top',  // Match original position
            padding: 25,
            labels: {
              font: {
                // Add font options here if needed
              }
            }
          },
          datalabels: {
            display: false
          },
          tooltip: {

          }
        },
        scales: {
          y: {
            beginAtZero: true,
            position: 'left',
            grid: {
              display: true,
              color: "#e4e6e8",
            },
            ticks: {
              maxTicksLimit: 10,
              font: {
                size: 10
              },
            }
          },
          x: {
            grid: {
              display: false
            },
            ticks: {
              maxTicksLimit: 8,  // Match original maxTicksLimit
              font: {
                size: 10
              },
              maxRotation: 0,
              minRotation: 0,
            },
          }
        }
      }
    };
  },
  render() {
    return h('div', { style: { height: '500px' } }, [
      h(Line, {
        data: this.chartData,
        options: this.options
      })
    ]);
  }
});
